<ion-modal>
    <ng-template>
        <div class="overflow-y-auto">
            <div class="flex-align-center inset-0 flex">
                <div class="flex-column flex h-full w-full bg-white">
                    <div class="p-4 py-5">
                        <div class="grid grid-cols-[1rem_1fr_1rem] gap-2 pb-5 pt-1">
                            <button (click)="closeModal()">
                                <ion-icon class="text-2xl text-primary" name="arrow-back-outline"></ion-icon>
                            </button>
                            <h2 class="text-center text-base font-bold leading-7">
                                {{ 'SELECT_CARD_TO_TOP_UP' | translate }}
                            </h2>
                        </div>

                        <form [formGroup]="cardForm" (ngSubmit)="setCardNumber()">
                            <ion-label class="mb-2 text-base leading-5">
                                {{ 'ENTER_OTHER_CARD_NUMBER' | translate }}
                            </ion-label>
                            <ion-input
                                class="rounded-lg border border-solid border-[#F2F2F2] bg-grey-white_smoke"
                                [maxlength]="cardValidationLength"
                                formControlName="cardNumber"
                                type="text"
                                inputmode="numeric"
                                placeholder="{{ 'ENTER_CARD_NUMBER' | translate }}">
                            </ion-input>

                            <ridango-error
                                class="text-xs font-bold text-red-500"
                                *ngIf="shouldShowError('cardNumber', 'pattern')">
                                {{ 'CARD_NUMBER_INVALID' | translate }}
                            </ridango-error>
                            <ridango-error
                                class="text-xs font-bold text-red-500"
                                *ngIf="shouldShowError('cardNumber', 'required')">
                                {{ 'CARD_NUMBER_REQUIRED' | translate }}
                            </ridango-error>

                            <p class="mt-1 text-xs font-bold text-ironside_grey">
                                {{ 'LOCATED_IN_LOWER_RIGHT_CORNER' | translate }}
                            </p>

                            <div class="mt-3">
                                <button
                                    class="text-bold w-full rounded-lg bg-secondary py-5 font-bold leading-5 text-white dark:bg-contrast-yellow dark:text-contrast-black"
                                    type="submit">
                                    {{ 'CONFIRM_CARD' | translate }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</ion-modal>
